import React from 'react';

const ServiceIcon = ({ type }) => {
  const paths = {
    cube: (
      <path
        d="M12 3l8 4.5v9L12 21l-8-4.5v-9L12 3z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    ),
    spark: (
      <path
        d="M12 3v4M12 17v4M3 12h4M17 12h4M5.6 5.6l2.8 2.8M15.6 15.6l2.8 2.8M18.4 5.6l-2.8 2.8M8.4 15.6l-2.8 2.8"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    ),
    megaphone: (
      <path
        d="M4 10v4h4l7 4V6L8 10H4zM15 8.5a3 3 0 010 7"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    ),
    screen: (
      <path
        d="M4 6h16v10H4zM8 20h8"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    ),
    target: (
      <>
        <circle cx="12" cy="12" r="7" fill="none" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="12" cy="12" r="2.5" fill="currentColor" />
      </>
    ),
    pencil: (
      <path
        d="M4 20l2-1 9-9 3 3-9 9-1 2H4v-4zM14 6l3 3"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    ),
  };

  return (
    <svg viewBox="0 0 24 24" className="site-refresh__service-icon" aria-hidden="true">
      {paths[type]}
    </svg>
  );
};

const PreviewServices = ({ items }) => (
  <section className="site-refresh__section" id="servicos">
    <div className="site-refresh__shell site-refresh__services-layout">
      <div className="site-refresh__services-copy">
        <div className="site-refresh__eyebrow">O que fazemos</div>
        <h2 className="site-refresh__section-title site-refresh__section-title--large">
          Visual innovation em grandes escalas
        </h2>
        <p className="site-refresh__intro">
          Criamos experiências visuais que conectam marcas ao público com narrativa,
          tecnologia e impacto. Do conceito à entrega final, nosso time transforma ideias
          em conteúdos memoráveis para campanhas, produtos e ambientes imersivos.
        </p>
        <a href="#cases" className="site-refresh__button site-refresh__button--outline" style={{display: 'none'}}>
          Conheça todos os serviços
          <span className="site-refresh__arrow" aria-hidden="true">
            →
          </span>
        </a>
      </div>

      <div className="site-refresh__service-grid">
        {items.map((item) => (
          <article key={item.id} className="site-refresh__service-card">
            <ServiceIcon type={item.icon} />
            <h3 className="site-refresh__service-title">{item.title}</h3>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default PreviewServices;
